import * as types from './mutation-types';

export default {
  [types.SET_STONE_CONFIGURATED](state, payload) {
    state.stoneConfigurated = payload;
  },
};
